import axios from 'axios';
var API = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL !== undefined ? process.env.VUE_APP_BACKEND_URL : 'http://localhost:3000',
    withCredentials: true
});
export var getPlatforms = function (filters) {
    return API.post('/platforms/list', filters);
};
export var viewPlatform = function (id) {
    return API.get("/platforms/".concat(id));
};
export var createPlatform = function (record) {
    return API.post('/admin/platforms', record);
};
export var getGroups = function (filters) {
    return API.post('/admin/groups/list', filters);
};
export var createGroup = function (record) {
    return API.post('/admin/groups', record);
};
export var updateGroup = function (id, record) {
    return API.patch("/admin/groups/".concat(id), record);
};
export var extendGroup = function (id, params) {
    return API.patch("/admin/groups/extend/".concat(id), params);
};
export var viewGroup = function (id) {
    return API.get("/admin/groups/".concat(id));
};
export var getStatus = function () {
    return API.get('/admin/groups/status');
};
